import { render, staticRenderFns } from "./PhoneRepeaterBasic.vue?vue&type=template&id=a16281ee&scoped=true"
import script from "./PhoneRepeaterBasic.vue?vue&type=script&lang=js"
export * from "./PhoneRepeaterBasic.vue?vue&type=script&lang=js"
import style0 from "./PhoneRepeaterBasic.vue?vue&type=style&index=0&id=a16281ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16281ee",
  null
  
)

export default component.exports